import React, { useState, useEffect, forwardRef, useCallback, useMemo } from 'react';
import './BackButton.css';
import { ReactComponent as BackIcon } from '../../../../assets/icon/caret-chevron-left.svg';
import Button from '../Button/Button';
import { useNavigate } from 'react-router-dom';

const BackButton: React.FC<{ }> = ({ }) => {
  const navigate = useNavigate();

  const handleBack = useCallback(async () => {
    navigate(-1);
  }, [navigate]);

  const handleBackButton = useMemo(() => (
    <div className='back-button-container'>
      <Button onClick={handleBack} icon={<BackIcon />} size={'small'} isSecondary={true} />
    </div>
  ), [handleBack]);

  return (
    <>
      { handleBackButton }
    </>
  );
};

export default BackButton;
